export default __webpack_public_path__ + "static/media/SAS Alert Tone 3.602c2bf4.wav";